
import React from 'react';
import { UserManagementContainer } from './user-management/UserManagementContainer';

export const GlobalUserManagement = () => {
  return <UserManagementContainer />;
};
